import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BroadcastService",
  controller: "TaskPlan",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "GetItemById",
  "GetPageContentByConditions",
  "FindByConditions",
  "AddItemList",
  "UpdateItemList"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const TaskPlanApi = ZJApi.defineNewApi("TaskPlanApi", factory);

export default TaskPlanApi;
